export const QA_53 = 99535353;
export const PROD_53 = 53;
export const PORTAL_53_HUBLET_PROPERTY_NAME = 'hublet_53';
export const PORTAL_53_PORTAL_ID_PROPERTY_NAME = 'portal_id';
export const PORTAL_53_PORTALS_OBJECT_TYPE_ID = '2-5945472';
export const PORTAL_53_QA_PORTALS_OBJECT_TYPE_ID = '2-5868076';